import React from 'react'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box } from '../../../components/mui/Core/index'
import GenericSnackbar from '../../../components/GenericSnackbar/generic-snackbar'
import GenericNav from '../../../components/genericcomponents/navbars/GenericNav'
import { hasUserPermission } from '../../../utils/user-utils'
import { userPermissionConstants } from '../../../constants/user-permission-constants'
import ErrorState from '../../../components/ErrorState/error-state'
import { errorCodes } from '../../../constants/error-codes'

function RoleManagementOutlet() {
  const authenticatedUser = useSelector((state) => state.login.authenticatedUser)

  const hasRoleManagementAccess = hasUserPermission({
    permissionCode: userPermissionConstants.VIEW_ROLE_MANAGEMENT,
    permissions: authenticatedUser?.permissions,
  })

  if (!hasRoleManagementAccess) {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <GenericNav selected='Role Management' user='authenticated' />
        <ErrorState errorCode={errorCodes.http.ERROR_UNAUTHORIZED} />
      </Box>
    )
  }

  return (
    <>
      <GenericNav />
      <Outlet />
      <GenericSnackbar />
    </>
  )
}

export default RoleManagementOutlet
